import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { parse } from 'qs';

import { Loader, Maker } from 'components';

import { cancelInitialize, initialize, setSidebar } from 'redux/reducers/app'

import styles from './styles.scss';

@connect(
  state => ({
    initializing: state.getIn(['app', 'ui', 'initializing'], true),
  }),
  {
    cancelInitialize,
    initialize,
    setSidebar,
  }
)
export default class Initializer extends React.PureComponent {
  static childContextTypes = {
    orderId: PropTypes.string,
    bookId: PropTypes.number,
  };

  getChildContext(props = this.props) {
    const { orderId = null, bookId = null } = props.match.params;

    return {
      orderId,
      bookId: bookId ? parseInt(bookId) : null,
    };
  }

  componentWillMount() {
    const { orderId, bookId } = this.getChildContext();
    const { setSidebar } = this.props;
    const { path, params } = this.props.match;
    let createOrder = false;

    if (path.slice(0, 9) === '/giftcard') {
      const query = parse(this.props.location.search.substring(1));
      setSidebar('giftcard', { ...params, ...query });
    } else if (path === '/create') {
      const query = parse(this.props.location.search.substring(1));
      const padLeft = nr => Array(2 - String(nr).length + 1).join('0') + nr;

      createOrder = {
        book: query.book,
        name: query.name,
        birthday: `${query.year}-${padLeft(query.month)}-${padLeft(query.day)}`,
      };
    }
    this.props.cancelInitialize()
    this.props.initialize(bookId, orderId, createOrder);
  }

  componentWillUpdate(nextProps) {
    if (this.idsWillChange(nextProps)) {
      const { orderId, bookId } = this.getChildContext(nextProps);
      this.props.cancelInitialize()
      this.props.initialize(bookId, orderId);
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.idsWillChange(nextProps) ||
      this.props.initializing !== nextProps.initializing ||
      this.props.location.pathname !== nextProps.location.pathname
    );
  }

  idsWillChange(nextProps) {
    const { orderId, bookId } = this.getChildContext();
    const { orderId: nextOrderId, bookId: nextBookId } = this.getChildContext(nextProps);

    return orderId !== nextOrderId || bookId !== nextBookId;
  }

  render() {
    const { initializing } = this.props;

    return (
      <div className={styles.app}>
        {!initializing ? (
          <Route path="/:bookId?/:orderId?" component={Maker} />
        ) : (
          <div className={styles.loading}>
            <Loader className={styles.loader} />
            {kroostApp.strings.loadingFirstMessage}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/initializer/index.js